<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="当天日期">
<!--                  <el-input  v-model="queryForm.dayDate"></el-input>-->
                  <el-date-picker
                      style="width: 177px;"
                      size="small"
                      v-model="queryForm.dayDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="商户总流水">
                  <el-input style="width: 177px;" v-model="queryForm.data1"></el-input>
              </el-form-item>
              <el-form-item label="商户总应收">
                  <el-input style="width: 177px;" v-model="queryForm.data2"></el-input>
              </el-form-item>
              <el-form-item label="商家总让利池">
                  <el-input style="width: 177px;" v-model="queryForm.data3"></el-input>
              </el-form-item>
              <el-form-item label="让利总分配池">
                  <el-input style="width: 177px;" v-model="queryForm.data4"></el-input>
              </el-form-item>
              <el-form-item label="公司运营池">
                  <el-input style="width: 177px;" v-model="queryForm.data5"></el-input>
              </el-form-item>
              <el-form-item label="活跃用户贡献池">
                  <el-input style="width: 177px;" v-model="queryForm.data6"></el-input>
              </el-form-item>
              <el-form-item label="活跃悦豆池">
                  <el-input style="width: 177px;" v-model="queryForm.data7"></el-input>
              </el-form-item>
              <el-form-item label="商家活动池">
                  <el-input style="width: 177px;" v-model="queryForm.data8"></el-input>
              </el-form-item>
              <el-form-item label="不活跃贡献池">
                  <el-input style="width: 177px;" v-model="queryForm.data9"></el-input>
              </el-form-item>
              <el-form-item label="悦果分配池">
                  <el-input style="width: 177px;" v-model="queryForm.data10"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getOperationDailyGlobalDataList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addOperationDailyGlobalData"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editOperationDailyGlobalData(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteOperationDailyGlobalData(null)"
        >删除</el-button>
          <el-button
          type="primary"
          plain
          size="small"
          @click="settingOperationDailyGlobalData()"
        >全局数据发放</el-button>
		
		<el-button
		  type="primary"
		  plain
		  size="small"
		  @click="settingOperationSubsidyGlobalData()"
		>补贴数据发放</el-button>
		
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshOperationDailyGlobalDataList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="operationDailyGlobalDataList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dayDate"
        label="当天日期"
        width="150"
      > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="exeStatus"
	    label="执行状态"
	    width="150"
	  > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="sendStatus"
	    label="发送状态"
	    width="150"
	  > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="exeLog"
	    label="执行日志"
	    width="150"
	  >
          <template slot-scope="scop">
              <span @click="openExeLog(scop.row.exeLog)">点击查看</span>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data1"
        label="商户总流水"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data2"
        label="商户总应收"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data3"
        label="商家总让利池"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data4"
        label="让利总分配池"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data5"
        label="公司运营池"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data6"
        label="活跃用户贡献池"
        width="180"
      > </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data66"
        label="活跃用户总贡献数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data7"
        label="活跃悦豆池"
        width="180"
      > </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data77"
        label="活跃商家总悦豆数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data8"
        label="商家活动池"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data9"
        label="不活跃贡献池"
        width="180"
      > </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data99"
        label="不活跃总贡献值数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data10"
        label="悦果分配池"
        width="180"
      > </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="data1010"
        label="总悦果数"
        width="180"
      > </el-table-column>
	  
	  
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="data12"
	    label="贡献值不活跃-补贴金额"
	    width="180"
	  > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="data1212"
	    label="贡献值不活跃-总数量"
	    width="180"
	  > </el-table-column>
	  
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="data13"
	    label="贡献值活跃-补贴金额"
	    width="180"
	  > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="data1313"
	    label="贡献值活跃-总数量"
	    width="180"
	  > </el-table-column>
	  
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="data14"
	    label="悦豆不活跃-补贴金额"
	    width="180"
	  > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="data1414"
	    label="悦豆不活跃-总数量"
	    width="180"
	  > </el-table-column>
	  
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="data15"
	    label="悦豆活跃-补贴金额"
	    width="180"
	  > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="data1515"
	    label="悦豆活跃-总数量"
	    width="180"
	  > </el-table-column>
	  
	  
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="data16"
	    label="悦果不活跃-补贴金额"
	    width="180"
	  > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="data1616"
	    label="悦果不活跃-总数量"
	    width="180"
	  > </el-table-column>
	  
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="data17"
	    label="悦果活跃-补贴金额"
	    width="180"
	  > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="data1717"
	    label="悦果活跃-总数量"
	    width="180"
	  > </el-table-column>
	  
	  
	  
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkOperationDailyGlobalData(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editOperationDailyGlobalData(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteOperationDailyGlobalData(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="operationDailyGlobalDataStates[operationDailyGlobalDataState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="operationDailyGlobalData"
          ref="operationDailyGlobalDataForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="当天日期"
            prop="dayDate"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="operationDailyGlobalData.dayDate"-->
<!--              :disabled="operationDailyGlobalDataState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  style="width: 177px;"
                  size="small"
                  v-model="operationDailyGlobalData.dayDate"
                  :disabled="operationDailyGlobalDataState == 'check'"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
          </el-form-item>
          <el-form-item
            label="商户总流水"
            prop="data1"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyGlobalData.data1"
              :disabled="operationDailyGlobalDataState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="商户总应收"
            prop="data2"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyGlobalData.data2"
              :disabled="operationDailyGlobalDataState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="商家总让利池"
            prop="data3"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyGlobalData.data3"
              :disabled="operationDailyGlobalDataState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="让利总分配池"
            prop="data4"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyGlobalData.data4"
              :disabled="operationDailyGlobalDataState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="公司运营池"
            prop="data5"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyGlobalData.data5"
              :disabled="operationDailyGlobalDataState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="活跃用户贡献池"
            prop="data6"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyGlobalData.data6"
              :disabled="operationDailyGlobalDataState == 'check'"
            ></el-input>
          </el-form-item>
            <el-form-item
            label="活跃用户总贡献数"
            prop="data66"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyGlobalData.data66"
              :disabled="operationDailyGlobalDataState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="活跃悦豆池"
            prop="data7"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyGlobalData.data7"
              :disabled="operationDailyGlobalDataState == 'check'"
            ></el-input>
          </el-form-item>
            <el-form-item
            label="活跃商家总悦豆数"
            prop="data77"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyGlobalData.data77"
              :disabled="operationDailyGlobalDataState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="商家活动池"
            prop="data8"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyGlobalData.data8"
              :disabled="operationDailyGlobalDataState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="不活跃贡献池"
            prop="data9"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyGlobalData.data9"
              :disabled="operationDailyGlobalDataState == 'check'"
            ></el-input>
          </el-form-item>
            <el-form-item
            label="不活跃总贡献值数"
            prop="data99"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyGlobalData.data99"
              :disabled="operationDailyGlobalDataState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="悦果分配池"
            prop="data10"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyGlobalData.data10"
              :disabled="operationDailyGlobalDataState == 'check'"
            ></el-input>
          </el-form-item>
            <el-form-item
            label="总悦果数"
            prop="data1010"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyGlobalData.data1010"
              :disabled="operationDailyGlobalDataState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="operationDailyGlobalDataState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
      <el-dialog
      title="执行日志"
      :visible.sync="showExeLog"
      width="400px"
      @close="closeExeLog"
      >
          <div>
              <el-input
                    size="small"
                    type="textarea"
                    :rows="9"
                    :disabled="true"
                    v-model="exeLog"
                ></el-input>
          </div>
           <div
            slot="footer"
            class="flex justify-end"
          >
            <el-button @click="closeExeLog">关闭</el-button>
          </div>
      </el-dialog>


  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetOperationDailyGlobalDataList();
                    this.getOperationDailyGlobalDataList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetOperationDailyGlobalDataList();
                    this.getOperationDailyGlobalDataList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     dayDate: '', //
                     data1: '', //商户总流水
                     data2: '', //商户总应收
                     data3: '', //商家总让利池
                     data4: '', //让利总分配池
                     data5: '', //公司运营池
                     data6: '', //活跃用户贡献池
                     data7: '', //活跃悦豆池
                     data8: '', //商家活动池
                     data9: '', //不活跃贡献池
                     data10: '', //悦果分配池
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                showExeLog: false,
                exeLog: '',
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                operationDailyGlobalDataState: 'add',
                operationDailyGlobalDataStates: {
                    add: '新建全局记录',
                    check: '查看全局记录',
                    edit: '修改全局记录'
                },

                multipleSelection: [],
                operationDailyGlobalDataList: [],
                operationDailyGlobalData: {
                    id: '', //
                    dayDate: '', //
                    data1: '', //商户总流水
                    data2: '', //商户总应收
                    data3: '', //商家总让利池
                    data4: '', //让利总分配池
                    data5: '', //公司运营池
                    data6: '', //活跃用户贡献池
                    data66: '',
                    data77: '',
                    data99: '',
                    data1010: '',
                    data7: '', //活跃悦豆池
                    data8: '', //商家活动池
                    data9: '', //不活跃贡献池
                    data10: '', //悦果分配池
                },
                btnLoading: false,

                rules: {
                    dayDate: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    data1: [{ required: true, message: '商户总流水不能为空', trigger: 'blur' }],
                    data2: [{ required: true, message: '商户总应收不能为空', trigger: 'blur' }],
                    data3: [{ required: true, message: '商家总让利池不能为空', trigger: 'blur' }],
                    data4: [{ required: true, message: '让利总分配池不能为空', trigger: 'blur' }],
                    data5: [{ required: true, message: '公司运营池不能为空', trigger: 'blur' }],
                    data6: [{ required: true, message: '活跃用户贡献池不能为空', trigger: 'blur' }],
                    data7: [{ required: true, message: '活跃悦豆池不能为空', trigger: 'blur' }],
                    data8: [{ required: true, message: '商家活动池不能为空', trigger: 'blur' }],
                    data9: [{ required: true, message: '不活跃贡献池不能为空', trigger: 'blur' }],
                    data10: [{ required: true, message: '悦果分配池不能为空', trigger: 'blur' }],
                    data66: [{ required: true, message: '活跃用户总贡献数不能为空', trigger: 'blur' }],
                    data77: [{ required: true, message: '活跃商家总悦豆数不能为空', trigger: 'blur' }],
                    data99: [{ required: true, message: '不活跃总贡献值数不能为空', trigger: 'blur' }],
                    data1010: [{ required: true, message: '总悦果数不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getOperationDailyGlobalDataList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            openExeLog(val){
                this.showExeLog = true;
                this.exeLog = val;
            },
            closeExeLog(){
                this.showExeLog = false;
                this.exeLog = '';
            },
            resetOperationDailyGlobalDataList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.operationDailyGlobalDataList = [];
            },
            settingOperationDailyGlobalData(){
                get('/quartz/globaldata/sendGlobalData').then((res)=>{
                    if(res.success){
                        this.$message.success(res.msg)
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
			settingOperationSubsidyGlobalData(){
                get('/quartz/globaldata/sendSubsidy').then((res)=>{
                    if(res.success){
                        this.$message.success(res.msg)
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
            resetDialog() {
                this.operationDailyGlobalDataState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      dayDate: '', //
                      data1: '', //商户总流水
                      data2: '', //商户总应收
                      data3: '', //商家总让利池
                      data4: '', //让利总分配池
                      data5: '', //公司运营池
                      data6: '', //活跃用户贡献池
                      data7: '', //活跃悦豆池
                      data8: '', //商家活动池
                      data9: '', //不活跃贡献池
                      data10: '', //悦果分配池
                };
                this.getOperationDailyGlobalDataList();
            },
            closeDialog() {
                this.showDialog = false
                this.operationDailyGlobalData = {
                      id: '', //
                      dayDate: '', //
                      data1: '', //商户总流水
                      data2: '', //商户总应收
                      data3: '', //商家总让利池
                      data4: '', //让利总分配池
                      data5: '', //公司运营池
                      data6: '', //活跃用户贡献池
                      data7: '', //活跃悦豆池
                      data8: '', //商家活动池
                      data9: '', //不活跃贡献池
                      data10: '', //悦果分配池
                    data66: '',
                    data77: '',
                    data99: '',
                    data1010: '',
                };
            },
            submitForm() {
                if (this.operationDailyGlobalDataState == 'add') {
                    this.$refs.operationDailyGlobalDataForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/operation/dailyglobaldata/add`,{ ...this.operationDailyGlobalData }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetOperationDailyGlobalDataList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.operationDailyGlobalDataState == 'edit') {
                    this.$refs.operationDailyGlobalDataForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/operation/dailyglobaldata/edit`,{ ...this.operationDailyGlobalData }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetOperationDailyGlobalDataList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addOperationDailyGlobalData() {
                this.showDialog = true;
                this.operationDailyGlobalDataState = 'add';
            },
            checkOperationDailyGlobalData(operationDailyGlobalDataId) {
                console.log(operationDailyGlobalDataId);
                this.currentOperationDailyGlobalDataId = operationDailyGlobalDataId;

                this.getOperationDailyGlobalDataById();
                this.showDialog = true;
                this.operationDailyGlobalDataState = 'check';
            },
            editOperationDailyGlobalData(operationDailyGlobalDataId) {
                console.log('operationDailyGlobalData', operationDailyGlobalDataId);
                if (operationDailyGlobalDataId) {
                    this.currentOperationDailyGlobalDataId = operationDailyGlobalDataId;
                    this.getOperationDailyGlobalDataById();
                } else {
                    this.operationDailyGlobalData = { ...this.operationDailyGlobalData, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.operationDailyGlobalDataState = 'edit';
            },
            deleteOperationDailyGlobalData(operationDailyGlobalDataId) {
                let ids = '';
                if (operationDailyGlobalDataId) {
                    ids = operationDailyGlobalDataId;
                } else {
                    ids = this.multipleSelection.map((operationDailyGlobalData) => operationDailyGlobalData.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/operation/dailyglobaldata/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetOperationDailyGlobalDataList();
                                this.getOperationDailyGlobalDataList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshOperationDailyGlobalDataList() {
                this.resetOperationDailyGlobalDataList();
                this.getOperationDailyGlobalDataList();
            },
            getOperationDailyGlobalDataList(query = {}) {
                this.loading = true;
                get(`/operation/dailyglobaldata/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.operationDailyGlobalDataList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getOperationDailyGlobalDataById() {
                get(`/operation/dailyglobaldata/get`,{ id: this.currentOperationDailyGlobalDataId }).then((res) =>{
                    if(res.success){
                      this.operationDailyGlobalData = { ...this.operationDailyGlobalData, ...res.operationDailyGlobalData };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportOperationDailyGlobalDataList() {
                //this.btnLoading = true;
                exprotExcel(`/operation/dailyglobaldata/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/operation/dailyglobaldata/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/operation/dailyglobaldata/importData`,formData);
              this.refreshOperationDailyGlobalDataList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getOperationDailyGlobalDataList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getOperationDailyGlobalDataList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>